export default {"src":"/_next/static/media/years-in-business.b83a886a.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};